<template>
  <CollapsibleLinks>
    <template #trigger="{ toggle }">
      <a
        class="font-bold text-primary hover:text-primary-dark text-lg"
        @click.stop.prevent="toggle"
        >{{ $t("footer.useful") }}</a
      >
    </template>
    <div class="flex flex-col mb-3 gap-1 text-sm">
      <FooterClickLink
        v-for="type in documentTypes"
        :key="type"
        :to="
          localePath({
            name: 'documentsTypePage',
            params: { type: typeSlug(type) },
          })
        "
        class="text-white"
      >
        {{ $t(`documents.types.${type}`) }}
      </FooterClickLink>
      <template v-if="$branding.isJoszaki">
        <FooterClickLink
          :to="localePath({ name: 'documentsCookiesPage' })"
          class="text-white"
        >
          {{ $t("documents.cookies.title") }}
        </FooterClickLink>
        <FooterClickLink class="text-white" @click="openCookieSettings">
          {{ $t("footer.cookieSettings") }}
        </FooterClickLink>
      </template>
      <FooterClickLink
        v-if="notCzechOrGerman"
        :to="localePath({ name: 'faqPage' })"
        class="text-white"
        >{{ $t("footer.faq") }}</FooterClickLink
      >
      <FooterClickLink
        v-if="!$branding.isSuperprofikCz"
        :to="localePath({ name: 'aboutUs' }) + '#impressum'"
        class="text-white"
      >
        {{ $t("footer.impressum") }}
      </FooterClickLink>
      <FooterClickLink
        v-if="contactFormUrl"
        :href="contactFormUrl"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.contacts") }}
      </FooterClickLink>
    </div>
  </CollapsibleLinks>
</template>

<script>
import CollapsibleLinks from "./CollapsibleLinks.vue";
import FooterClickLink from "./FooterClickLink.vue";
import { useSettingsStore } from "~/stores/settings";
import { openCookieSettings } from "~/config/cookiebot";
import {
  LEGAL_DOCUMENT_TYPES,
  getLegalDocumentTypeSlug,
} from "~/config/legalDocumentTypes";

export default {
  components: { CollapsibleLinks, FooterClickLink },
  setup() {
    const settingsStore = useSettingsStore();
    return { contactFormUrl: settingsStore.contactForm };
  },
  computed: {
    documentTypes() {
      return LEGAL_DOCUMENT_TYPES;
    },
    notCzechOrGerman() {
      return !this.$branding.isSuperprofikCz && !this.$branding.isBerufExperten;
    },
  },
  methods: {
    openCookieSettings,
    typeSlug(type) {
      return getLegalDocumentTypeSlug(type, this.$i18n);
    },
  },
};
</script>
